module.exports = "assets/d36a0d2e30d149e278e50fd2b0be94c6.gif";